export const DOMAINE_SHOW_RESET = "DOMAINE_SHOW_RESET";
export const DOMAINE_SHOW_SET_ERROR = "DOMAINE_SHOW_SET_ERROR";
export const DOMAINE_SHOW_SET_RETRIEVED = "DOMAINE_SHOW_SET_RETRIEVED";
export const DOMAINE_SHOW_TOGGLE_LOADING = "DOMAINE_SHOW_TOGGLE_LOADING";
